<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设施运维</el-breadcrumb-item>
        <el-breadcrumb-item>运维管理</el-breadcrumb-item>
        <el-breadcrumb-item>演练工单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工单ID">
                <el-input v-model="searchForm.TicketId" placeholder="请输入工单ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="园区">
                <el-select clearable v-model="searchForm.CampusName" placeholder="请选择" style="width: 100%">
                  <el-option label="张家口-怀来瑞北" value="张家口怀来瑞北"></el-option>
                  <el-option label="清远-清城" value="清远清城"></el-option>
                  <el-option label="贵阳-贵安七星" value="贵阳贵安七星"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划开始">
                <el-date-picker
                  v-model="searchForm.createTime"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-tabs v-model="activeTab" class="custom-tabs" @tab-click="handleTabChange">

      <el-tab-pane label="演练工单列表" name="drillList">
        <div class="title-en">演练工单列表</div>
        <el-card class="box-card">
          <div class="table-container">
            <div class="button-container">
              <el-button @click="openColumnsDialog">表头设置</el-button>
            </div>
            <el-table :data="tableData" border stripe @selection-change="handleSelectionChange" ref="table"
              v-loading="loading">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
                :label="column.label" :width="column.width">
                <template slot-scope="scope">
                  <span v-if="
                    column.prop === 'CreateTime' ||
                    column.prop === 'UpdateTime' ||
                    column.prop === 'PlanStartTime' ||
                    column.prop === 'RealStartTime' ||
                    column.prop === 'RealEndTime'
                  ">{{
                    scope.row[column.prop]
                      ? $moment(scope.row[column.prop]).format('YYYY-MM-DD')
                      : '-'
                  }}</span>
                  <span v-else>{{ scope.row[column.prop] || '-' }}</span>
                </template>
              </el-table-column>
            </el-table>

            <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="600px"
              :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
              :destroy-on-close="true">
              <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
                <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
                  {{ column.label }}
                </el-checkbox>
              </el-checkbox-group>
              <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="selectAllColumns">全选</el-button>
                <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
                <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
              </div>
            </el-dialog>

            <div class="pagination-container">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" />
            </div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getDrillTicketInfo } from '@/api/operation';

import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

export default {
  name: 'ManpowerService',
  data() {
    return {
      activeTab: 'drillList',
      debouncedExport: null,
      tableData: [],
      searchForm: {
        TicketId: '',
        CampusName: '',
        MozuName: '',
        TaskName: '',
        InspType: '',
        PlanStartTime: '',
        RealStartTime: '',
        RealEndTime: '',
        InspStatus: '',
        createTime: [],
        UpdateTime: '',
        start_time: '',
        end_time: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'TicketId',
        'AllTimeOffsetRate',
        'CampusName',
        'CampusTimeOffsetRate',
        'ChangeId',
        'ComplianceCheck',
        'ComplianceCheckNote',
        'ComplianceRate',
        'DcManagerUser',
        'DrillMajor',
        'DrillMode',
        'DrillType',
        'EndTime',
        'EndUser',
        'ExercisePlan',
        'FmcCheckStatus',
        'FmcTicketId',
        'GroupUsers',
        'InstanceId',
        'IsOmService',
        'IsPassNote',
        'MozuName',
        'OmComfirmNote',
        'OmConfirm',
        'OmSummary',
        'OmUsers',
        'Operation',
        'OperationsUsers',
        'Optimizer',
        'PdfUrl',
        'PlanId',
        'RegionName',
        'Resluts',
        'ReslutsList',
        'ScoreCount',
        'StartTime',
        'Step1Notify',
        'Step2Notify',
        'Summary',
        'TicketCheckTime',
        'TicketCheckUser',
        'TicketCreatTime',
        'TicketReslut',
        'TicketStatus',
        'TimeConsumEnd',
        'TimeConsumEnd1',
        'UsersCount',
        'WorkingHoursCheck'
      ],
      defaultSelectedColumns: [
        'AllTimeOffsetRate',
        'CampusName',
        'CampusTimeOffsetRate',
        'ChangeId',
        'ComplianceCheck',
        'ComplianceCheckNote',
        'ComplianceRate',
        'DcManagerUser',
        'DrillMajor',
        'DrillMode',
        'DrillType',
        'EndTime',
        'EndUser',
        'ExercisePlan',
        'FmcCheckStatus',
        'FmcTicketId',
        'GroupUsers',
        'InstanceId',
        'IsOmService',
        'IsPassNote',
        'MozuName',
        'OmComfirmNote',
        'OmConfirm',
        'OmSummary',
        'OmUsers',
        'Operation',
        'OperationsUsers',
        'Optimizer',
        'PdfUrl',
        'PlanId',
        'RegionName',
        'Resluts',
        'ReslutsList',
        'ScoreCount',
        'StartTime',
        'Step1Notify',
        'Step2Notify',
        'Summary',
        'TicketCheckTime',
        'TicketCheckUser',
        'TicketCreatTime',
        'TicketId',
        'TicketReslut',
        'TicketStatus',
        'TimeConsumEnd',
        'TimeConsumEnd1',
        'UsersCount',
        'WorkingHoursCheck'
      ],
      columns: [
        { prop: 'TicketId', label: '工单ID',width:150 },
        { prop: 'MozuName', label: '模组' },
        { prop: 'StartTime', label: '开始时间',width: 150 },
        { prop: 'ScoreCount', label: '得分' },
        { prop: 'ReslutsList', label: '不合格项' },
        { prop: 'ComplianceCheck', label: '合规判定' },
        { prop: 'FmcCheckStatus', label: '园区审批状态' },
        { prop: 'Step1Notify', label: '故障现象描述', width: 300 },
        { prop: 'Step2Notify', label: '故障原因描述', width: 320 },
        { prop: 'OmSummary', label: '综合运维管理服务工程师总结',width: 300 },
        { prop: 'TicketCreatTime', label: '工单创建时间',width: 150 },
        { prop: 'InstanceId', label: '行事历ID', width: 150 },
        { prop: 'TicketStatus', label: '工单状态' },
        { prop: 'EndTime', label: '结束时间' ,width: 150},
        { prop: 'ComplianceRate', label: '达标率' },
        { prop: 'Resluts', label: '审核结果' },
        { prop: 'TicketCheckUser', label: '单条工单审批人' },
        { prop: 'OperationsUsers', label: '运维参与人员', width: 410 },
        { prop: 'AllTimeOffsetRate', label: '全国平均耗时偏离度' },
        { prop: 'OmConfirm', label: '综合运维管理服务审批结果' },
        { prop: 'IsPassNote', label: '数经审批意见' },
        { prop: 'PlanId', label: '行事历ID' },
        { prop: 'DrillType', label: '演练类型' },
        { prop: 'TimeConsumEnd1', label: '故障定位耗时' },
        { prop: 'Optimizer', label: '优化参与人' },
        { prop: 'GroupUsers', label: '班组' ,width: 300},
        { prop: 'TicketCheckTime', label: '单条工单审批时间' ,width: 150},
        { prop: 'Summary', label: '演练总结' ,width: 390},
        { prop: 'CampusTimeOffsetRate', label: '园区历史平均耗时偏离度' },
        { prop: 'OmComfirmNote', label: '综合运维管理服务审批理由' },
        { prop: 'DcManagerUser', label: '参与的数经用户' },
        { prop: 'RegionName', label: '区域' },
        { prop: 'DrillMajor', label: '专业' },
        { prop: 'TimeConsumEnd', label: '故障处理耗时' },
        { prop: 'Operation', label: '是否实操:是/否' },
        { prop: 'DrillMode', label: '普通工单/即时工单' },
        { prop: 'TicketReslut', label: '单条工单审批结果' },
        { prop: 'ComplianceCheckNote', label: '单条工单审批不合格原因' },
        { prop: 'PdfUrl', label: 'PDF URL', width: 260 },
        { prop: 'IsOmService', label: '是否综合运维管理服务工程师参与' },
        { prop: 'CampusName', label: '园区' },
        { prop: 'ExercisePlan', label: '演练方案', width: 220 },
        { prop: 'UsersCount', label: '参与人数' },
        { prop: 'ChangeId', label: '变更单号' },
        { prop: 'WorkingHoursCheck', label: '工时审核' },
        { prop: 'FmcTicketId', label: 'FMC审批工单号' },
        { prop: 'OmUsers', label: '综合运维管理服务工程师' },
        { prop: 'EndUser', label: '演练实施结单人' }
      ],
      visibleColumns: [],
      selectedRows: [],
      loading: false,
      tableDataAll: [],
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 设置默认时间范围为当前自然月
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.createTime = [
      this.$moment(firstDay).format('YYYY-MM-DD'),
      this.$moment(lastDay).format('YYYY-MM-DD'),
    ];
    this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD');
    this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD');
    this.fetchData();
    // this.fetchDataAll();
    this.handleDateChange(this.searchForm.createTime);
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    handleTabChange(tab) {
      if (tab.index === '0') {
        this.fetchData();
      } else {
        this.fetchData();
      }
    },
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.createTime = dates;
        this.searchForm.start_time = this.$moment(dates[0]).format('YYYY-MM-DD');
        this.searchForm.end_time = this.$moment(dates[1]).format('YYYY-MM-DD');
      } else {
        // 如果清空日期，重置为当前自然月
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.searchForm.createTime = [
          this.$moment(firstDay).format('YYYY-MM-DD'),
          this.$moment(lastDay).format('YYYY-MM-DD'),
        ];
        this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD');
        this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD');
      }
    },
    async fetchData() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        campusName: this.searchForm.CampusName || null,
        TicketId: this.searchForm.TicketId || null,
        StartTime_gte: this.searchForm.start_time,
        StartTime_lte: this.searchForm.end_time,
      };

      // 添加结束时间的时分秒
      if (params.end_time) {
        params.end_time = this.$moment(params.end_time).format('YYYY-MM-DD');
      }

      this.loading = true;

      try {
        const response = await getDrillTicketInfo(params);
        if (response.data) {
          this.tableData = response.data.data.data || [];
          this.total = response.data.data.counts || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    async fetchDataAll() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        campusName: this.searchForm.CampusName || null,
        TicketId: this.searchForm.TicketId || null,
        StartTime_gte: this.searchForm.start_time,
        StartTime_lte: this.searchForm.end_time

      };

      // 添加结束时间的时分秒
      if (params.end_time) {
        params.end_time = this.$moment(params.end_time).format('YYYY-MM-DD');
      }

      this.loading = true;

      try {
        const response = await getDrillTicketInfo(params);
        if (response.data) {
          this.tableDataAll = response.data.data.data || [];
          this.total = response.data.data.counts || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      if (this.activeTab === 'drillList') {
        this.fetchData();
      } else {
        this.fetchData();
      }
    },
    handleReset() {
      // 重置所有搜索条件
      this.searchForm = {
        TicketId: '',
        CampusName: '',
        MozuName: '',
        TaskName: '',
        InspType: '',
        PlanStartTime: '',
        RealStartTime: '',
        RealEndTime: '',
        InspStatus: '',
        CreateTime: '',
        UpdateTime: '',
        start_time: '',
        end_time: '',
      };
      // 重置为当前自然月
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD');
      this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD');
      this.currentPage = 1;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          // TODO: 替换为实际的导出API
          const response = await getDrillTicketInfo({
            campusName: this.searchForm.CampusName || null,
            TicketId: this.searchForm.TicketId || null,
            StartTime_gte: this.searchForm.start_time,
            StartTime_lte: this.searchForm.end_time,
            export_excel: 1,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.data || [];
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (
                    [
                      'CreateTime',
                      'UpdateTime',
                      'PlanStartTime',
                      'RealStartTime',
                      'RealEndTime',
                    ].includes(column.prop)
                  ) {
                    value = value ? this.$moment(value).format('YYYY-MM-DD') : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '演练工单');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `演练工单_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (
                  [
                    'CreateTime',
                    'UpdateTime',
                    'PlanStartTime',
                    'RealStartTime',
                    'RealEndTime',
                  ].includes(column.prop)
                ) {
                  value = value ? this.$moment(value).format('YYYY-MM-DD') : '-';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '人力服务');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `人力服务_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>

.custom-tabs {
  margin-bottom: 20px;
}

.analysis-container {
  min-height: 400px;
  padding: 20px;
}

.placeholder {
  color: #909399;
  font-size: 16px;
}

.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>